import { VenuesLayout } from '@layouts/venue/VenuesLayout'
import ClustersPage from '@pages/venues/ClustersPage'
import VenuesPage from '@pages/venues/VenuesPage'
import TagsPage from '@pages/venues/VenueTagsPage'
import { Navigate, RouteObject } from 'react-router-dom'
import venueDetailRoutes from './VenueDetailRoutes'

const venueRoutes: RouteObject[] = [
  {
    element: <VenuesLayout />,
    children: [
      { path: 'list', element: <VenuesPage /> },
      { path: 'tags', element: <TagsPage /> },
      { path: 'clusters', element: <ClustersPage /> },
      { index: true, element: <Navigate to="list" replace /> },
      { path: '*', element: <Navigate to="/404" replace /> },
    ],
  },
  {
    path: ':venueSlug',
    children: venueDetailRoutes,
  },
]

export default venueRoutes
